<!-- 平台管理 - 服务项目管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部服务项目</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form
                            ref="serviceItemQueryForm"
                            :model="serviceItemQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="5" :offset="4">
                                    <el-form-item prop="serviceName">
                                        <el-input
                                            v-model="
                                                serviceItemQueryForm.serviceName
                                            "
                                            :maxlength="100"
                                            placeholder="服务项目名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="serviceType">
                                        <el-select
                                            v-model="
                                                serviceItemQueryForm.serviceType
                                            "
                                            clearable
                                            placeholder="服务类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="汽车服务"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="市场营销"
                                                :value="2"
                                            ></el-option>
                                            <el-option
                                                label="车辆安全检测"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetServiceItemQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="queryServiceItemList(1000)"
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button
                            type="primary"
                            size="small"
                            icon="fas fa-plus-circle"
                            @click="openServiceItemEditDialog('add')"
                            >添加服务项目</el-button
                        >
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="serviceItemTable"
                            v-loading="serviceItemQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: serviceItemQueryLoading }"
                            :data="serviceItemList"
                            :default-sort="serviceItemQuerySort"
                            @sort-change="onServiceItemQuerySortChange"
                            style="width: 100%"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                label="#"
                                type="index"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                label="服务项目名称"
                                prop="serviceName"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="服务类型"
                                prop="serviceType"
                                width="200"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.serviceTypeName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="服务价格"
                                prop="servicePrice"
                                width="150"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="价格单位"
                                prop="priceUnit"
                                width="150"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="创建时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="140"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openServiceItemViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleServiceItemCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item command="edit"
                                                >修改项目</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除项目</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showServiceItemQueryPager"
                            @current-change="
                                onServiceItemQueryCurrentPageChange
                            "
                            :current-page.sync="
                                serviceItemQueryForm.currentPage
                            "
                            :page-size="serviceItemQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="serviceItemQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                serviceItemQueryForm.pageSize ==
                                                10,
                                        }"
                                        @click="
                                            onServiceItemQueryPageSizeChange(10)
                                        "
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceItemQueryForm.pageSize ==
                                                20,
                                        }"
                                        @click="
                                            onServiceItemQueryPageSizeChange(20)
                                        "
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceItemQueryForm.pageSize ==
                                                50,
                                        }"
                                        @click="
                                            onServiceItemQueryPageSizeChange(50)
                                        "
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceItemQueryForm.pageSize ==
                                                100,
                                        }"
                                        @click="
                                            onServiceItemQueryPageSizeChange(
                                                100
                                            )
                                        "
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="serviceItemEditDialogVisible"
                        @closed="closeServiceItemEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ serviceItemEditDialogTitle }}</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                ref="serviceItemEditForm"
                                :model="serviceItemEditForm"
                                :rules="serviceItemEditRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务项目名称"
                                            prop="serviceName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceItemEditForm.serviceName
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    2~50个汉字、字母、数字及下划线组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务类型"
                                            prop="serviceType"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        serviceItemEditForm.serviceType
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="汽车服务"
                                                        :value="1"
                                                    ></el-option>
                                                    <el-option
                                                        label="市场营销"
                                                        :value="2"
                                                    ></el-option>
                                                    <el-option
                                                        label="车辆安全检测"
                                                        :value="3"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务价格"
                                            prop="servicePrice"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceItemEditForm.servicePrice
                                                    "
                                                    :maxlength="10"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="价格单位"
                                            prop="priceUnit"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceItemEditForm.priceUnit
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务项目描述"
                                            prop="serviceDesc"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    type="textarea"
                                                    v-model="
                                                        serviceItemEditForm.serviceDesc
                                                    "
                                                    :maxlength="512"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeServiceItemEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveServiceItem"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="serviceItemViewDialogVisible"
                        @closed="closeServiceItemViewDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            查看服务项目详情</span
                        >
                        <div class="el-drawer-content">
                            <div class="el-drawer-content-body">
                                <el-form
                                    class="el-form-detail"
                                    inline
                                    label-position="right"
                                    label-width="120px"
                                    label-suffix="："
                                >
                                    <el-form-item label="服务项目ID">{{
                                        serviceItemViewForm.serviceId
                                    }}</el-form-item>
                                    <el-form-item label="服务项目类型">{{
                                        serviceItemViewForm.serviceTypeName
                                    }}</el-form-item>

                                    <el-form-item
                                        label="服务项目名称"
                                        style="width: 100%"
                                        >{{
                                            serviceItemViewForm.serviceName
                                        }}</el-form-item
                                    >

                                    <el-form-item label="服务价格">{{
                                        serviceItemViewForm.servicePrice
                                    }}</el-form-item>
                                    <el-form-item label="价格单位">{{
                                        serviceItemViewForm.priceUnit
                                    }}</el-form-item>

                                    <el-form-item
                                        label="服务项目描述"
                                        style="width: 100%"
                                        >{{
                                            serviceItemViewForm.serviceDesc
                                        }}</el-form-item
                                    >

                                    <el-form-item label="创建时间">{{
                                        serviceItemViewForm.createTime
                                    }}</el-form-item>
                                    <el-form-item label="修改时间">{{
                                        serviceItemViewForm.updateTime
                                    }}</el-form-item>
                                </el-form>
                            </div>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeServiceItemViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

export default {
    name: 'ServiceItem',
    data() {
        return {
            submiting: false,
            serviceItemList: [],
            serviceItemQueryLoading: false,
            serviceItemQuering: false,
            serviceItemQueryForm: {
                serviceName: '',
                serviceType: '',
                pageSize: 10,
                currentPage: 1,
            },
            serviceItemQueryTotal: 0,
            serviceItemQuerySort: {
                prop: 'createTime',
                order: 'descending',
            },
            currentActionType: 'add',
            serviceItemEditDialogVisible: false,
            serviceItemViewDialogVisible: false,
            serviceItemEditForm: {
                serviceId: '',
                serviceName: '',
                serviceType: '',
                servicePrice: '',
                priceUnit: '',
                serviceDesc: '',
            },
            serviceItemEditRules: {
                serviceName: [
                    {
                        required: true,
                        message: '请输入服务项目名称!',
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message:
                            '服务项目名称由2~50个汉字、字母、数字及下划线组成!',
                    },
                ],
                serviceType: [
                    {
                        required: true,
                        message: '请选择服务类型!',
                    },
                ],
                servicePrice: [
                    {
                        required: true,
                        message: '请输入服务价格!',
                    },
                    {
                        pattern: /^([0-9])+(\.[0-9]{1,2})?$/,
                        message: '服务价格必须是非负数,最多2位小数!',
                    },
                ],
                priceUnit: [
                    {
                        required: true,
                        message: '请输入价格单位!',
                    },
                ],
            },
            serviceItemViewForm: {
                serviceId: '',
                serviceName: '',
                serviceType: '',
                serviceTypeName: '',
                servicePrice: '',
                priceUnit: '',
                serviceDesc: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
            },
        };
    },
    computed: {
        showServiceItemQueryPager() {
            if (this.serviceItemQuering || this.serviceItemQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        serviceItemEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加服务项目';
            } else if (this.currentActionType == 'edit') {
                return '修改服务项目';
            } else {
                return '';
            }
        },
    },
    created() {},
    mounted() {
        this.queryServiceItemList(1000);
    },
    methods: {
        queryServiceItemList(loading) {
            this.serviceItemQueryForm.currentPage = 1;
            this.doQueryServiceItemList(loading);
        },
        doQueryServiceItemList(loading) {
            this.serviceItemQuering = true;
            if (loading) {
                this.serviceItemQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.serviceItemQueryForm,
                    mapSort(this.serviceItemQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/serviceitem/list'),
                        {
                            params: params,
                        }
                    )
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.serviceItemList = result.data;
                            this.serviceItemQueryTotal = result.totalRowCount;
                        } else {
                            this.serviceItemList = [];
                            this.serviceItemQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.serviceItemList = [];
                        this.serviceItemQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.serviceItemQueryLoading = false;
                        }
                        this.serviceItemQuering = false;
                    });
            }, loading);
        },
        resetServiceItemQueryForm() {
            this.$refs.serviceItemQueryForm.resetFields();
        },
        onServiceItemQuerySortChange(parameter) {
            if (
                this.serviceItemQuerySort.prop != parameter.prop ||
                this.serviceItemQuerySort.order != parameter.order
            ) {
                this.serviceItemQuerySort.prop = parameter.prop;
                this.serviceItemQuerySort.order = parameter.order;
                this.queryServiceItemList(1000);
            }
        },
        onServiceItemQueryPageSizeChange(pageSize) {
            this.serviceItemQueryForm.pageSize = pageSize;
            this.queryServiceItemList(1000);
        },
        onServiceItemQueryCurrentPageChange(currentPage) {
            this.serviceItemQueryForm.currentPage = currentPage;
            this.doQueryServiceItemList(1000);
        },
        handleServiceItemCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openServiceItemEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openServiceItemViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteServiceItem(row);
            }
        },
        openServiceItemEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.serviceItemEditDialogVisible = true;
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.serviceItemEditForm).forEach((name) => {
                        let value = row[name];
                        this.serviceItemEditForm[name] = value;
                    });
                });
            }
        },
        closeServiceItemEditDialog() {
            this.submiting = false;
            this.serviceItemEditDialogVisible = false;
            this.$refs.serviceItemEditForm.resetFields();
            //手动reset
            this.serviceItemEditForm.serviceId = '';
        },
        openServiceItemViewDialog(cmd, row) {
            this.currentActionType = cmd;
            this.serviceItemViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.serviceItemViewForm).forEach((name) => {
                    let value = row[name];
                    this.serviceItemViewForm[name] = value;
                });
            });
        },
        closeServiceItemViewDialog() {
            this.serviceItemViewDialogVisible = false;
            Object.keys(this.serviceItemViewForm).forEach((name) => {
                this.serviceItemViewForm[name] = '';
            });
        },
        deleteServiceItem(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/serviceitem/delete/' + row.serviceId
            );
            this.$confirm('您确定要删除该服务项目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$http
                    .delete(url)
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryServiceItemList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        saveServiceItem() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of('/api/platform/visp/serviceitem/create');
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of('/api/platform/visp/serviceitem/update');
                method = 'put';
            }
            if (url) {
                this.$refs.serviceItemEditForm.validate((valid) => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.serviceItemEditForm)
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeServiceItemEditDialog();
                                        this.$message.success(result.message);
                                        this.queryServiceItemList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
    },
};
</script>